import React, { Component } from "react";
import Container from "../../common/application_container";
import { withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { getUser } from "../../../actions/session";
import Axios from "axios";
import {
  ACCOUNT_STATS_PER_DAY,
  ACCOUNT_TABLE_STATS,
} from "../../../config/rest_endpoints";
import { Notifications } from "../../common/notification";
import CustomLoader from "../../common/loader";
import { fmtDollar4, fmtMins, fmtInt } from '../../common/formatters';

// datetime picker imports
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";

class AccountPerDay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      User: getUser(),
      data: [],
      id: this.props.match.params.id,
      name: this.props.match.params.name,
      startDate: moment().startOf("day").toDate(),
      endDate: moment(),
      // startDate: setHours(setMinutes(setSeconds(new Date(), 0), 0), 0),
      // endDate: setHours(setMinutes(setSeconds(new Date(), 59), 59), 23),
      isGetting: false,
      isBtnSpin: false,
      isDownLoadSpin: false,
      sortColumn: null,
      sortDirection: "asc"
    };
    this.getReportOnSelectDate = this.getReportOnSelectDate.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }

  handleDate(date, value) {
    if (value == "start") {
      this.setState({ startDate: date }, () => {
        console.log("start", this.state.startDate);
      });
    } else {
      this.setState({ endDate: date }, () => {
        console.log("end", this.state.endDate);
      });
    }
  }

  handleSort(column) {
    
    const { sortColumn, sortDirection, data } = this.state;
    let newDirection = "asc";

    if (sortColumn === column) {
      newDirection = sortDirection === "asc" ? "desc" : "asc";
    }

    const sortedData = [...data].sort((a, b) => {
      let aValue = a[column];
      let bValue = b[column];

      // Handle createDate column
      if (column === "createDate") {
        aValue = new Date(aValue || 0).getTime();
        bValue = new Date(bValue || 0).getTime();
      }
      // Handle Intra Minutes and Inter Minutes specifically
      else if (column === "intrastateMinutes" || column === "interstateMinutes") {
        aValue = aValue === "N/A" || !aValue ? 0 : Number(aValue);
        bValue = bValue === "N/A" || !bValue ? 0 : Number(bValue);
      }
      // Handle percentage values (ASR, SDP)
      else if (column === "ASR" || column === "SDP") {
        aValue = aValue === "N/A" || !aValue ? 0 : parseFloat(aValue);
        bValue = bValue === "N/A" || !bValue ? 0 : parseFloat(bValue);
      }
      // Handle numeric values
      else if (["revenue", "cost", "profit", "minutes", "ACD", "completed", "inCalls", "outCalls", 
                "sdCount", "rejectedForCapacity", "indeterminateMinutes", "dcnCount", "actualMinutes"].includes(column)) {
        aValue = aValue === "N/A" || !aValue ? 0 : parseFloat(aValue);
        bValue = bValue === "N/A" || !bValue ? 0 : parseFloat(bValue);
      }
      // Handle attempts columns
      else if (column.startsWith("attempts_")) {
        aValue = aValue === "N/A" || !aValue ? 0 : parseFloat(aValue);
        bValue = bValue === "N/A" || !bValue ? 0 : parseFloat(bValue);
      }
      // Handle any other string values
      else {
        aValue = (aValue || "").toString().toLowerCase();
        bValue = (bValue || "").toString().toLowerCase();
      }

      if (newDirection === "asc") {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });

    this.setState({
      data: sortedData,
      sortColumn: column,
      sortDirection: newDirection,
    });
  }

  getSortIcon(column) {
    const { sortColumn, sortDirection } = this.state;
    if (sortColumn !== column) {
      return (
        <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
          <i className="icon-arrow-up8" style={{ fontSize: "13px", color: "#ccc" }}></i>
          <i className="icon-arrow-down8" style={{ fontSize: "13px", color: "#ccc" }}></i>
        </div>
      );
    }
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
        <i
          className="icon-arrow-up8"
          style={{
            fontSize: "13px",
            fontWeight: 900,
            color: sortDirection === "asc" ? "#4caf50" : "#ccc"
          }}
        ></i>
        <i
          className="icon-arrow-down8"
          style={{
            fontSize: "13px",
            fontWeight: 900,
            color: sortDirection === "desc" ? "#4caf50" : "#ccc"
          }}
        ></i>
      </div>
    );
  }

  getReportOnSelectDate(data) {
    const { User, startDate, endDate, selectedAccount, id } = this.state;
    var payload = {
      startDate: moment(startDate).format('MM/DD/YYYY, h:mm:ss A'),
      endDate: moment(endDate).format('MM/DD/YYYY, h:mm:ss A'),
    };
    console.log(`payload`, payload);
    this.setState({ isGetting: true, isBtnSpin: true, isDownLoadSpin: false });
    var headers = { Authorization: "Bearer " + User.token };
    console.log("headerssss", headers);
    if (data === "download") {
      this.setState({ isGetting: false, isBtnSpin: false, isDownLoadSpin: true });
      Axios.post(`${ACCOUNT_STATS_PER_DAY}/${id}?download=true`, payload, {
        headers,
      })
        .then((res) => {
          if (res) {
            var resp = res.data;
            console.log("resp", resp);
            const getFileName = res.headers["content-disposition"];
            const settingFileName = getFileName.replace(
              "attachment; filename=",
              ""
            );
            const url = window.URL.createObjectURL(new Blob([resp]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${settingFileName}.csv`);
            document.body.appendChild(link);
            Notifications.notify(
              "File is been downloading...",
              "Downloading",
              "success"
            );
            link.click();
            this.setState({ isGetting: false, isBtnSpin: false, isDownLoadSpin: false });
          }
        })
        .catch((err) => {
          const alert = err.response;
          console.log(`alert.data.message`, alert.data.message);
          if (alert.data.message === "invalid or expired jwt") {
            localStorage.removeItem("user");
            this.setState({ isLoginURL: true });
            Notifications.notify(alert.data.message, "Token Expire", "error");
          }
          Notifications.notify(alert.data.message, "Failed", "error");
          this.setState({
            isGetting: false,
            isBtnSpin: false
          });
        });
    } else {
      Axios.post(`${ACCOUNT_STATS_PER_DAY}/${id}`, payload, { headers })
        .then((res) => {
          if (res) {
            var resp = res.data.data || [];
            console.log(`accounts per day resp`, resp);
            this.setState({
              data: resp,
              isGetting: false,
              isBtnSpin: false
            });
          }
        })
        .catch((err) => {
          const alert = err.response;
          // console.log(`alert.data.message`, alert.data.message);
          if (alert.data.message === "invalid or expired jwt") {
            localStorage.removeItem("user");
            this.setState({ isLoginURL: true });
            Notifications.notify(alert.data.message, "Token Expire", "error");
          }
          Notifications.notify(alert.data.message, "Failed", "error");
          this.setState({
            isGetting: false,
          });
        });
    }
    // Axios.post(`${ACCOUNT_STATS_PER_DAY}/${id}`, payload, { headers })
    //   .then((res) => {
    //     if (res) {
    //       var resp = res.data.data;
    //       console.log(`accounts per day resp`, resp);
    //       this.setState({
    //         data: resp,
    //         isGetting: false,
    //       });
    //     }
    //   })
    //   .catch((err) => {
    //     const alert = err.response;
    //     console.log(`alert.data.message`, alert.data.message);
    //     if (alert.data.message === "invalid or expired jwt") {
    //       localStorage.removeItem("user");
    //       this.setState({ isLoginURL: true });
    //       Notifications.notify(alert.data.message, "Token Expire", "error");
    //     }
    //     Notifications.notify(alert.data.message, "Failed", "error");
    //     this.setState({
    //       isGetting: false,
    //     });
    //   });
  }

  accountStatsReportTable() {
    const { data, isGetting } = this.state;
    if (data.length === 0 || data === null) {
      return (
        <div className="ml-3 mt-3">
          <div
            className="dataTables_info"
            id="DataTables_Table_0_info"
            role="status"
            aria-live="polite"
          >
            Showing 0 of 0 entries
          </div>
          <div
            className="dataTables_paginate paging_simple_numbers"
            id="DataTables_Table_0_paginate"
          ></div>
        </div>
      );
    } else {
      return data.map((stats, idx) => {
        return (
          <tr key={idx} className="right_align">
            <td className="table-data">{stats.createDate}</td>
            <td className="table-data" style={{textAlign:'right'}}>{fmtDollar4(stats.revenue)}</td>
            <td className="table-data" style={{textAlign:'right'}}>{fmtDollar4(stats.cost)}</td>
            <td className="table-data" style={{textAlign:'right'}}>{fmtDollar4(stats.profit)}</td>
            <td className="table-data" style={{textAlign:'right'}}>{fmtMins(stats.minutes)}</td>
            <td className="table-data" style={{textAlign:'right'}}>{stats.ACD}</td>
            <td className="table-data" style={{textAlign:'right'}}>{stats.SDP}</td>
            <td className="table-data" style={{textAlign:'right'}}>{stats.ASR}</td>
            <td className="table-data" style={{textAlign:'right'}}>{fmtInt(stats.completed)}</td>
            <td className="table-data" style={{textAlign:'right'}}>{fmtInt(stats.inCalls)}</td>
            <td className="table-data" style={{textAlign:'right'}}>{fmtInt(stats.outCalls)}</td>
            <td className="table-data" style={{textAlign:'right'}}>{fmtInt(stats.sdCount)}</td>
            <td className="table-data" style={{textAlign:'right'}}>{fmtInt(stats.rejectedForCapacity)}</td>
            <td className="table-data" style={{textAlign:'right'}}>{fmtMins(stats.indeterminateMinutes)}</td>
            <td className="table-data" style={{textAlign:'right'}}>{fmtMins(stats.intrastateMinutes)}</td>
            <td className="table-data" style={{textAlign:'right'}}>{fmtMins(stats.interstateMinutes)}</td>
            <td className="table-data" style={{textAlign:'right'}}>{fmtInt(stats.dcnCount)}</td>
            <td className="table-data" style={{textAlign:'right'}}>{stats.attempts_404 || "N/A"}</td>
            <td className="table-data" style={{textAlign:'right'}}>{stats.attempts_487 || "N/A"}</td>
            <td className="table-data" style={{textAlign:'right'}}>{stats.attempts_4xx || "N/A"}</td>
            <td className="table-data" style={{textAlign:'right'}}>{stats.attempts_503 || "N/A"}</td>
            <td className="table-data" style={{textAlign:'right'}}>{stats.attempts_5xx || "N/A"}</td>
            <td className="table-data" style={{textAlign:'right'}}>{stats.attempts_6xx || "N/A"}</td>
          </tr>
        );
      });
    }
  }

  render() {
    const { name, startDate, endDate, isGetting, data, isBtnSpin, isDownLoadSpin } = this.state;
    return (
      <Container
        title={name.toUpperCase() + " Reports"}
        title1="Information"
        icon="icon-lan"
      >
        <div style={{ border: 'none', borderRadius: '5px', boxShadow: '0 0 20px rgba(0,0,0,.08)' }} className="card card-body">
          <div className="card-header header-elements-inline p-0 py-1 mb-1">
            <h5 style={{ fontWeight: '700', fontSize: '24px' }} className="card-title"></h5>
            <div className="header-elements">
            </div>
          </div>
          {/* heading section */}
          <div class="d-flex justify-content-between flex-wrap bg-light rounded border p-0 mb-2">
            <div class=" py-2 px-3 mb-1">
              <div class="">
                <label style={{ fontWeight: '400', fontSize: '16px' }} className="fs-14">
                  Start Date
                  <span className="text-muted "> UTC Time-zone</span>{" "}
                </label>
                <div class="input-group">
                  <DateRangePicker
                    showWeekNumbers
                    onCallback={(date) => this.handleDate(date, "start")}
                    initialSettings={{
                      singleDatePicker: true,
                      // timePicker: true,
                      showDropdowns: true,
                      startDate: moment(startDate),
                      locale: {
                        format: "MMMM/DD/YYYY",
                      },
                    }}
                  >
                    <input
                      type="text"
                      className="form-control"
                      style={{ minWidth: "300px" }}
                    />
                  </DateRangePicker>
                </div>
              </div>
            </div>
            <div class="py-2 px-3 mb-1">
              <div class="">
                <label style={{ fontWeight: '400', fontSize: '16px' }} className="fs-14">
                  End Date
                  <span className="text-muted "> UTC Time-zone</span>{" "}
                </label>
                <div class="input-group">
                  <DateRangePicker
                    onCallback={(date) => this.handleDate(date, "end")}
                    initialSettings={{
                      singleDatePicker: true,
                      // timePicker: true,
                      showDropdowns: true,
                      startDate: moment(endDate),
                      locale: {
                        format: "MMMM/DD/YYYY",
                      },
                    }}
                  >
                    <input
                      type="text"
                      className="form-control"
                      style={{ minWidth: "300px" }}
                    />
                  </DateRangePicker>
                </div>
              </div>
            </div>
            <div class="py-2 px-3 mb-1">
              <div
                className=""
                style={{ marginTop: "2.5em" }}
              >
                <button
                  type="submit"
                  className="btn main-button btn-success btn-sm border "
                  onClick={this.getReportOnSelectDate}
                >
                  Search <i class={`${isBtnSpin ? 'icon-spinner4 spinner' : 'icon-arrow-right8'} ml-2`}></i>
                </button>
              </div>
            </div>
          </div>
          {/* form filed section */}
          <div className="card-header header-elements-inline p-0 py-1 mb-2">
            <h5 style={{ fontWeight: '700', fontSize: '24px' }} className="card-title"></h5>
            <div className="header-elements">
              <button
                style={{ fontWeight: '600' }}
                type="submit"
                className="btn btn-success btn-sm main-button float-right "
                onClick={this.getReportOnSelectDate.bind(this, "download")}
              >
                Download CSV <i class={`${isDownLoadSpin ? 'icon-spinner4 spinner' : 'icon-download7'} ml-2`}></i>
              </button>
            </div>
          </div>
          {/* daownload button */}
          <div className="table-responsive" style={{ overflowX: "auto", overflowY: "auto", maxHeight: "56em" }}>
            <table className="table-style table table-striped dataTable no-footer">
              <thead>
                <tr className="stickeyHeader table-heading-style">
                  <th style={{ cursor: "pointer" }} onClick={() => this.handleSort("createDate")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      <span>Create Date</span>
                      {this.getSortIcon("createDate")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("revenue")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>Revenue</span>
                      {this.getSortIcon("revenue")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("cost")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>Cost</span>
                      {this.getSortIcon("cost")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("profit")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>Profit</span>
                      {this.getSortIcon("profit")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("minutes")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>Minutes</span>
                      {this.getSortIcon("minutes")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("ACD")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>ACD</span>
                      {this.getSortIcon("ACD")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("SDP")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>SDP</span>
                      {this.getSortIcon("SDP")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("ASR")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>ASR</span>
                      {this.getSortIcon("ASR")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("completed")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>Completed</span>
                      {this.getSortIcon("completed")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("inCalls")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>In Calls</span>
                      {this.getSortIcon("inCalls")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("outCalls")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>Out Calls</span>
                      {this.getSortIcon("outCalls")}
                    </div>
                  </th>

                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("rejectedForCapacity")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>Rejected For Capacity</span>
                      {this.getSortIcon("rejectedForCapacity")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("indeterminateMinutes")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>Indeterminate Minutes</span>
                      {this.getSortIcon("indeterminateMinutes")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("intrastateMinutes")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>Intra Minutes</span>
                      {this.getSortIcon("intrastateMinutes")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("interstateMinutes")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>Inter Minutes</span>
                      {this.getSortIcon("interstateMinutes")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("dcnCount")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>DNC Count</span>
                      {this.getSortIcon("dcnCount")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("attempts_404")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>404%</span>
                      {this.getSortIcon("attempts_404")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("attempts_487")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>487%</span>
                      {this.getSortIcon("attempts_487")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("attempts_4xx")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>4XX%</span>
                      {this.getSortIcon("attempts_4xx")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("attempts_503")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>503%</span>
                      {this.getSortIcon("attempts_503")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("attempts_5xx")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>5XX%</span>
                      {this.getSortIcon("attempts_5xx")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} onClick={() => this.handleSort("attempts_6xx")}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>6XX%</span>
                      {this.getSortIcon("attempts_6xx")}
                    </div>
                  </th>
                  <th style={{ cursor: "pointer", textAlign: "right" }} >
                    <div style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "flex-end" }}>
                      <span>SD Count</span>
                      {/* {this.getSortIcon("sdCount")} */}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {isGetting ? <CustomLoader /> : this.accountStatsReportTable()}
              </tbody>
            </table>

          </div>
          {/* table section */}
          <ReactTooltip
            type="success"
            backgroundColor="#4caf50"
            place="top"
            effect="solid"
          />

        </div>
      </Container>
    );
  }
}
export default withRouter(AccountPerDay);
